import { inject, Injectable } from '@angular/core';

import { LogService } from '@ups/xplat/core';
import { DynamicRenderService } from '../services/dynamic-render.service';
import { IDynamicPageOptions } from '../models/dynamic.interface';

interface PageFormDetailComponent {
  dynamicPage: {
    draftReady: boolean;
  };
  options: IDynamicPageOptions;
}

@Injectable({
  providedIn: 'root',
})
export class DynamicPageGuard {
  private dynamicService = inject(DynamicRenderService);
  private log = inject(LogService);

  canDeactivate(component: PageFormDetailComponent): Promise<boolean> {
    return new Promise((resolve) => {
      if (
        component?.dynamicPage?.draftReady &&
        !component.options?.dynamicResponseId
      ) {
        try {
          this.dynamicService
            .confirmSaveActiveFormAsDraft()
            .then(
              () => {
                resolve(true);
              },
              () => {
                resolve(true);
              }
            )
            .catch(() => {
              resolve(true);
            });
        } catch {
          resolve(true);
        }
      } else {
        resolve(true);
      }
    });
  }
}
